<template>
  <div class="w-full">
    <div
      class="model input flex items-center w-full pl-4 pr-4"
      @click="openDetail"
    >
      <input
        v-if="type === null"
        type="text"
        v-model="value"
        class="inputt w-full h-full"
        :placeholder="placeholder"
      >

      <input
        v-if="type !== null"
        type="text"
        v-model="value"
        class="inputt w-full h-full"
        :placeholder="placeholder"
        @keypress="isNumberOnly"
      >
    </div>{{ sendValue }}
  </div>
</template>

<script>

export default {
  name: 'Index',
  components: {
  },
  props: {
    value: {
      type: String,
      default: null
    },
    type: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: 'Civilité'
    }
  },
  data () {
    return {
      activeDetail: false,
      selectedItem: null
    }
  },
  computed: {
    sendValue: function () {
      this.$emit('info', this.value)
    }
  },
  methods: {
    startWrite () {
      this.value = ''
    },
    openDetail () {
      this.activeDetail = !this.activeDetail
    },
    isNumberOnly ($event) {
      const keyCode = ($event.keyCode ? $event.keyCode : $event.which)
      if ((keyCode < 42 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../assets/style/sass/variables";

.model{
  font-weight: 600;
  font-size: 14.1603px;
  line-height: 17px;
  color: $form-text;
}

.inputt{
  font-weight: normal;
  font-size: 18px;
  line-height: 160%;
  color: #909090;
  border: none;
  background: transparent;
}
.input{
  height: 71px;
  background: rgba(211, 217, 235, 0.2);
  border: 1px solid #D3D9EB;
  box-sizing: border-box;
  border-radius: 0px;
}
</style>
